import mapDefaultValue from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/DeployModal/mapDefaultValue';
import { removeUiFields } from 'app/playbook-editor/revision-header/download-upload/download/remove-ui-fields';

export default function translatePlaybookJson({
  playbookJson,
  deprecatedPipelineVariables,
  pipelineVars,
  playbookPipelineVariables,
}) {
  return removeUiFields(
    mapDefaultValue(playbookJson, deprecatedPipelineVariables, pipelineVars, playbookPipelineVariables)
  );
}
